/**
 * Sign-In Redirect Utilities
 *
 * Handles redirecting to sign-in page with return URL
 */

import { isValidReturnUrl } from "./urlValidation.js";
import { storeReturnUrl } from "./returnUrlHandlers.js";

/**
 * Generate sign-in URL with return parameter
 * @param {string} returnUrl - URL to return to after sign-in
 * @param {string} signInBaseUrl - Base URL for sign-in page (optional)
 * @returns {string} - Complete sign-in URL with return parameter
 */
export const createSignInUrl = (returnUrl = null, signInBaseUrl = null) => {
  // Use current location if no return URL provided
  const finalReturnUrl = returnUrl || window.location.href;

  // Default sign-in URL (you can configure this)
  const signInUrl = signInBaseUrl || `${window.location.origin}/signin`;

  // Create URL with return parameter
  const url = new URL(signInUrl);

  if (finalReturnUrl && isValidReturnUrl(finalReturnUrl)) {
    url.searchParams.set("returnUrl", finalReturnUrl);

    // Also store in session as backup
    storeReturnUrl(finalReturnUrl);
  }

  return url.toString();
};

/**
 * Redirect to sign-in page with return URL
 * @param {string} returnUrl - URL to return to after sign-in (optional, defaults to current page)
 * @param {string} signInBaseUrl - Base URL for sign-in page (optional)
 */
export const redirectToSignIn = (returnUrl = null, signInBaseUrl = null) => {
  const signInUrl = createSignInUrl(returnUrl, signInBaseUrl);
  window.location.href = signInUrl;
};
